export const getTempRoleSelector = (state) => state?.auth?.tempRole;
export const getAuthStatus = (state) => state?.auth?.status;
export const getPathname = (state) => state?.router?.location.pathname;
export const getLocation = (state) => {
  return state?.router?.location?.state?.from?.pathname || '/';
};
export const getSearchQuery = (state) => {
  return state?.router?.location?.state?.from?.search || '';
};
